export enum PartTypeEnum {
	OEM = 1,
	IAM = 2,
	Generic = 3,
	Recycled = 4,
	Airbag = 5,
	Suspension = 6,
	Glass = 7,
	Tire = 8,
	Radiator = 9,
	Wheel = 10,
	Paint = 11,
	BumberRepair = 12,
	Diagnostic = 13,
}
